export enum UserPermission {
  RegistrationRequest = 'registration',
  MasterDataChange = 'masterdataChange',
  CallbackRequest = 'callbackRequest',
  PushMessages = 'pushMessages',
}
